module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/3_2b0df69daac40751d188d8ddf9425777.png";